import { directionColors, marketSeriesChartOption } from "./chartOptions.js";

const STOCK_INTRADAY_TICKS = new Set([
  "09:30", "10:00", "10:30", "11:00", "11:30",
  "13:00", "13:30", "14:00", "14:30", "15:00",
]);

function palette() {
  // 同 chartOptions.js：单测在 node 里跑，没有 document，取不到就用兜底值。
  const css = typeof document === "undefined" || typeof getComputedStyle !== "function"
    ? null
    : getComputedStyle(document.documentElement);
  const { up, down } = directionColors();
  return {
    ink: css?.getPropertyValue("--semantic-ink").trim() || "#101828",
    muted: css?.getPropertyValue("--semantic-muted").trim() || "#667085",
    line: css?.getPropertyValue("--soft-line").trim() || "#edf2ee",
    // 方向色统一从 chartOptions 的 directionColors() 取。原来借用 danger/success
    // 表达涨跌，那两个令牌是「危险/成功」的语义，方向一改就对不上（2026-09-02 实测）。
    up,
    down,
    blue: css?.getPropertyValue("--semantic-info").trim() || "#2563eb",
  };
}

export function stockKlineOption(bars = []) {
  const colors = palette();
  const dates = bars.map((bar) => bar.t);
  const volumes = bars.map((bar, index) => ({
    value: Number(bar.volume_shares),
    itemStyle: { color: Number(bar.close) >= Number(bar.open) ? colors.up : colors.down },
    xAxisIndex: 1,
    yAxisIndex: 1,
    dataIndex: index,
  }));
  return {
    animation: false,
    axisPointer: { link: [{ xAxisIndex: "all" }] },
    tooltip: { trigger: "axis", axisPointer: { type: "cross" } },
    grid: [
      { left: 62, right: 28, top: 24, height: "63%" },
      { left: 62, right: 28, top: "75%", height: "14%" },
    ],
    xAxis: [
      { type: "category", data: dates, boundaryGap: true, axisLabel: { show: false }, axisLine: { lineStyle: { color: colors.line } } },
      { type: "category", gridIndex: 1, data: dates, boundaryGap: true, axisLabel: { color: colors.muted, hideOverlap: true }, axisLine: { lineStyle: { color: colors.line } } },
    ],
    yAxis: [
      { scale: true, axisLabel: { color: colors.muted }, splitLine: { lineStyle: { color: colors.line } } },
      { scale: true, gridIndex: 1, splitNumber: 2, axisLabel: { color: colors.muted, formatter: (value) => `${(value / 10000).toFixed(0)}万` }, splitLine: { show: false } },
    ],
    dataZoom: [
      { type: "inside", xAxisIndex: [0, 1], start: Math.max(0, 100 - 80 * 100 / Math.max(bars.length, 1)), end: 100 },
      { type: "slider", xAxisIndex: [0, 1], height: 18, bottom: 2, borderColor: colors.line, fillerColor: "rgba(37,99,235,.08)" },
    ],
    series: [
      {
        name: "K线",
        type: "candlestick",
        data: bars.map((bar) => [Number(bar.open), Number(bar.close), Number(bar.low), Number(bar.high)]),
        itemStyle: { color: colors.up, color0: colors.down, borderColor: colors.up, borderColor0: colors.down },
      },
      {
        name: "MA20",
        type: "line",
        data: bars.map((bar) => bar.ma20 === null ? null : Number(bar.ma20)),
        showSymbol: false,
        smooth: true,
        lineStyle: { width: 1.5, color: colors.blue },
      },
      { name: "成交量", type: "bar", xAxisIndex: 1, yAxisIndex: 1, data: volumes },
    ],
  };
}

export function stockIntradayOption(points = [], previousClose = null, name = "价格") {
  const option = marketSeriesChartOption({
    data: {
      series: [{ name, unit: "CNY", points }],
    },
  }, "intraday", previousClose);
  const priceSeries = option.series?.[0];
  if (priceSeries) {
    priceSeries.lineStyle = { ...priceSeries.lineStyle, color: "#356ae6" };
    priceSeries.areaStyle = { color: "#356ae612" };
  }
  (option.xAxis ?? []).forEach((axis) => {
    axis.axisLabel = {
      ...axis.axisLabel,
      interval: 0,
      formatter: (value) => STOCK_INTRADAY_TICKS.has(value) ? value : "",
    };
  });
  return option;
}
